import React, { useEffect, useState } from 'react';
import { SupportedDevises, WarningSVG } from '../../assets/SVGAssets';
import CheckDevice from './checkDevice';
import Header from '../../components/header/Header';

import decor1 from '../../assets/images/icon3.webp';

import './changeDeviceWarning.css';

export default function ChangeDeviceWarning() {
    const isMobile = () => CheckDevice();
    const [device, setDevice] = useState(isMobile() ? 'mobile' : 'other');

    const onWindowChangeDevice = () => {
        setDevice(isMobile() ? 'mobile' : 'other');
    };

    useEffect(
        () => (
            // eslint-disable-next-line
            onWindowChangeDevice(),
            window.addEventListener('resize', onWindowChangeDevice),
            () => window.removeEventListener('resize', onWindowChangeDevice)
        ),
        [],
    );

    return (
        <div
            className="changeDeviceWrapper"
            style={{ display: device === 'mobile' ? 'block' : 'none' }}>
            <Header />
            <div className="changeDeviceBorders">
                <div className="changeDevice-border left"></div>
                <div className="changeDevice-border right"></div>
            </div>

            <div className="changeDeviceTitle">
                <WarningSVG />
            </div>

            <div className="changeDeviceContent">
                <h1>oops!</h1>

                <p>quiz will not be displayed correctly on mobile devices</p>
                <SupportedDevises />
                <p className="bold">It works better on tablet or desktop</p>
            </div>

            <img className="decor1" src={decor1} alt="decor" />
        </div>
    );
}
